export default function openExternalLink (externalLInk) {
  window.open(externalLInk,'_blank');
}

